module.exports = __webpack_public_path__ + "media/images/cover/cover-d3d14a65d4809b98675fe3bc882fb0d0.png";